import { render, staticRenderFns } from "./DesignerMenuList.vue?vue&type=template&id=1f3e3dc2&scoped=true"
import script from "./DesignerMenuList.vue?vue&type=script&lang=js"
export * from "./DesignerMenuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3e3dc2",
  null
  
)

export default component.exports